import { createFileRoute } from "@tanstack/react-router";
import { AuthPage } from "../components/auth/auth-page";
import { leaveIfSignedIn } from "../lib/session-gate";

export const Route = createFileRoute("/sign-up")({
  beforeLoad: leaveIfSignedIn,
  component: () => <AuthPage mode="sign-up" />,
});
